// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ae0c31e3","349":"c49a9502","362":"1d9ef92e","447":"f2a935e0","453":"ce513f15","507":"27e9faac","561":"17a07fbf","863":"d1b00e92"}[chunkId] + ".chunk.js";
};